/**
 * Lazy-loaded actions for the EAS English webinar funnel.
 */

export const funnelEnWebinarOptInAction = async (args: any) => {
    const module = await import("../pages/funnel/optin/action");
    return module.funnelEnWebinarOptInAction ? await module.funnelEnWebinarOptInAction(args) : null;
};

export const purchaseEnWebinarAction = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/webinar/purchaseEnWebinarAction");
    return module.purchaseEnWebinarAction ? await module.purchaseEnWebinarAction(args) : null;
};

export const saveEnWebinarQuizResultsAction = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/webinar/en/EnWebinarOptInConfirmationPage");
    return module.action ? await module.action(args) : null;
};

export const saveEnWebinarJitQuizResultsAction = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/webinar/en/EnWebinarOptInJustInTimeConfirmationPage");
    return module.action ? await module.action(args) : null;
};
